import React from "react";
import "../../../styles/utils/modal/OngoingModal.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

const OngoingModal = ({ onClose, onclose }) => {
  const { t } = useAppTranslation("components/utils/ongoingModal");
  const handleClose = onClose ?? onclose;

  return (
    <section className="ongoing-section">
      <div className="inner">
        <figure>
          <img src={"/images/utils/modal/busy-now.svg"} alt={t("alts.busy")} />
        </figure>
        <div className="txt-container">
          <p>{t("message")}</p>
          <button onClick={handleClose}>{t("actions.confirm")}</button>
        </div>
      </div>
    </section>
  );
};

export default OngoingModal;
